import { forwardRef } from 'react'
import { Typography } from '@mui/material'
import PropTypes from 'prop-types'

const Picto = forwardRef((props, ref) => {
  const { disabled, letter, onClick, ...rest } = props
  return (
    <Typography
      ref={ref}
      {...rest}
      sx={{
        color: '#ffffff',
        cursor: onClick ? 'pointer' : 'default',
        flexShrink: 0,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '0.8em',
        width: '1.4em',
        height: '1.4em',
        margin: '1px',
        position: 'relative',
        userSelect: 'none',
        zIndex: 0,
        '&:before': {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: disabled
            ? (theme) => theme.palette.inactive.background
            : (theme) => theme.palette.primary.main,
          borderRadius: '100%',
          width: '110%',
          height: '110%',
          zIndex: -1,
        },
      }}
      variant="picto"
      onClick={(e) => {
        e.stopPropagation()
        onClick?.()
      }}
    >
      {letter}
    </Typography>
  )
})

Picto.displayName = 'Picto'

Picto.propTypes = {
  disabled: PropTypes.bool,
  letter: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default Picto
